import Home from "pages/Home";
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import RevenueReport from "./revenue-report";
import ActionableList from "pages/ActionableList";
import EngagementV2 from "pages/EngagementV2";
import {
  getCurrentUserRole,
  DASHBOARD_HOME_ACCESS,
  REVENUE_REP_ACCESS,
  DASHBOARD_ACTIONABLE_ROUTE,
  currentUser,
  POST_SALES_FLAG,
} from "modules/utilities/utility";
import DoctorDashboard from "pages/AllopathyDoctorDashboard";
import DoctorsTab from "pages/DoctorsDashboard";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
} from "functionCall";

function Dashboard() {
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");
  const subTab = searchParams.get("subTab");
  const pageNumber = searchParams.get('page');

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    if (tabKey === "actionable") {
      if(subTab == 'openOrder'){
        navigate(`/dashboard?tab=${tabKey}&subTab=openOrder&page=1`);
      }
      else{
        navigate(`/dashboard?tab=${tabKey}&subTab=temporary`);
      }
    } else {
      navigate(`/dashboard?tab=${tabKey}`);
    }
  };

  useEffect(() => {
    setActiveTab(tab);
    if (tab === "actionable") {
      if(subTab == "openOrder"){
        navigate(`/dashboard?tab=${tab}&subTab=${subTab}&page=${pageNumber||1}`);
      }
      else{
        navigate(`/dashboard?tab=${tab}&subTab=${subTab}`);
      }
    } else {
      navigate(`/dashboard?tab=${tab}`);
    }
  }, [tab, subTab, pageNumber]);

  useEffect(() => {
    if (getCurrentUserRole() === "doctor") {
      navigate("/home?pageNo=1");
    }
    if (getCurrentUserRole() === "consult_doctor") {
      navigate(
        `/home?startDate=${encodeURIComponent(
          revenueRepStartDate(getFormattedEndDate(1))
        )}&endDate=${encodeURIComponent(
          revenueRepEndDate(getFormattedStartDate())
        )}`
      );
    }
    if (getCurrentUserRole() === "support"||getCurrentUserRole()==='admin') {
      navigate("/myTickets?tab=assigned");
      return;
    }
    if (["ivr","lead_agent"].includes(currentUser)) {
      navigate("/dashboard?tab=actionable");
      setActiveTab("actionable");
      return;
    } 
    if(DASHBOARD_ACTIONABLE_ROUTE.includes(getCurrentUserRole())){
      navigate("/dashboard?tab=actionable&subTab=temporary");
      setActiveTab("actionable");
      return;
    }
    else {
      return;
    }
  }, []);

  return (
    <div>
      {getCurrentUserRole() === "doctor" ? (
        <DoctorsTab />
      ) : getCurrentUserRole() === "consult_doctor" ? (
        <DoctorDashboard />
      ) : getCurrentUserRole()==='support'?null:(
        <Tabs
          variant="pills"
          defaultActiveKey="home"
          id="uncontrolled-tab-example"
          activeKey={activeTab}
          className="mb-1 "
          onSelect={handleTabChange}
        >
          {!DASHBOARD_HOME_ACCESS.includes(getCurrentUserRole()) && (
            <Tab eventKey="home" title="Home" className="border-top">
              <Home />
            </Tab>
          )}
          {REVENUE_REP_ACCESS.includes(getCurrentUserRole()) && (
            <Tab
              eventKey="revenue-report"
              title="Revenue Report"
              className="border-top p-3"
            >
              <RevenueReport tab={activeTab} />
            </Tab>
          )}
          <Tab eventKey="actionable" title="Actionable" className="border-top">
           <ActionableList actionable={true} tab={activeTab} />
          </Tab>
          {/* <Tab
          eventKey="engagementv2"
          title="Engagement V2"
          className="border-top p-3"
        >
          <EngagementV2 />
        </Tab> */}
        </Tabs>
      )}
    </div>
  );
}

export default Dashboard;
